module.exports = __webpack_public_path__ + "media/music/saw_lead_3-a4963899.mp3";